module.exports = __webpack_public_path__ + "img/中国羽毛球协会@2x.8ace1f81.png";